import "./App.css";
import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StartTourRegistrationForm from "./components/userJourney/StartTourRegistrationForm";
import MockShellComponent from "./components/userJourney/MockShellComponent";
import CompanyRegistrationForm from "./components/userJourney/CompanyRegistrationForm";
import GlobalRisks from "./components/global-risks/GlobalRisks";

const App = () => {
  return (
    <>
      <BrowserRouter>
        <ToastContainer />
        <Switch>
          <Route
            path="/"
            component={GlobalRisks}
          />
        </Switch>
        <Switch>
          <Route
            path="/kavida/start-tour"
            component={StartTourRegistrationForm}
          />
        </Switch>
        <Switch>
          <Route
            path="/kavida/create-company"
            component={CompanyRegistrationForm}
          />
        </Switch>
        <Switch>
          <Route
            path="/kavida/tour"
            component={MockShellComponent}
          />
        </Switch>
      </BrowserRouter>
    </>
  );
};
export default App;
